//测试环境
//const upload_url = 'http://jy.wxstores.com/Ali_oss/index';
//const admin_api = 'http://jy.wxstores.com/Admin';
const upload_url = 'https://api.poppets.com.cn/admin/Ali_oss/index';
const admin_api = 'https://api.poppets.com.cn/Admin';
// const admin_api = 'https://qinc-api.xiaocx.tech/Admin';
export default {
  upload_url,
  admin_api,
}



// WEBPACK FOOTER //
// ./src/util/common.js